export default "__VITE_ASSET__BZLtQAya__"